import { defineStore } from "pinia";
import api from "../utils/api";
export const useSearchStore = defineStore("search", {
  state: () => ({
    loading: false,
    // Group all parameters in a single object called `searchParams`
    searchParams: {
      searchHotelName: "",
      checkin: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000) // Today + 14 days
        .toISOString()
        .split("T")[0],
      checkout: new Date(Date.now() + 16 * 24 * 60 * 60 * 1000) // Today + 16 days
        .toISOString()
        .split("T")[0],
      sortBy: "name",
      rooms: [{ adults: 2, children: 0, ages: [] }],
      selectedAmenities: [],
      selectedLocation: [],
      selectedProperty: [],
    },
    isSearch:false,
    results: [],
    isLoading: false,
    amenities: [],
    listOfHotels: [],
    typeOfProperty: [],
    availableLocations: [],
    hotelId: null,
    selectedHotelName: "",
    searchedHotelName: "",
  }),
  actions: {
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },

    // Corrected formattedOccupancy function to return the formatted occupancy string
    

    // Setter for all properties inside searchParams
    setLoading(state, payload) {
      state.loading = payload;
    },
    setSearchParams(params) {
      this.searchParams = { ...this.searchParams, ...params };
    },

    // Setter for individual properties if needed
    setCheckin(checkinDate) {
      this.searchParams.checkin = checkinDate;
    },
    setCheckout(checkoutDate) {
      this.searchParams.checkout = checkoutDate;
    },
    setRooms(rooms) {
      this.searchParams.rooms = rooms;
    },
    setHotelRoomName(hotelName) {
      this.selectedHotelName = hotelName;
    },
    setHotelRoomId(hotelId) {
      this.hotelId = hotelId;
    },
    setSearch(search) {
      this.isSearch = search;
    },
    setsearchedHotelName(searchedHotelName) {
      this.searchedHotelName = searchedHotelName;
    },

    // The search function remains similar, modified to check params
    async search(inputParams) {
      this.listOfHotels = []
      // Use `inputParams` if provided, else fallback to `this.searchParams`
      const params = {
        // checkin: this.formatDate(
        //   inputParams?.checkin || this.searchParams.checkin
        // ),
        // checkout: this.formatDate(
        //   inputParams?.checkout || this.searchParams.checkout
        // ),
        // from: inputParams?.from || this.searchParams.barMinValue,
        // to: inputParams?.to || this.searchParams.barMaxValue,
        // rooms: inputParams?.rooms || this.searchParams.rooms,
        // search: true,
        searchHotelName:
          inputParams?.searchHotelName || this.searchParams.searchHotelName,
        sort_by: inputParams?.sort_by || this.searchParams.sortBy,
        propertyType:
          inputParams?.propertyType || this.searchParams.selectedProperty,
        locations: inputParams?.locations || this.searchParams.selectedLocation,
        amenities:
          inputParams?.amenities || this.searchParams.selectedAmenities,
        // per_page: 10,
      };
      if (inputParams?.checkin) {
        params.checkin = this.formatDate(inputParams?.checkin);
      }
      if (inputParams?.checkout) {
        params.checkout = this.formatDate(inputParams?.checkout);
      }
      this.isLoading = true;

      try {
        const response = await api.get(`/property/search`, {
          params,
        });
        if (response.status === 200) {
          this.results = response.data.data.properties.data;
          this.amenities = response.data.data.amenities;
          this.listOfHotels = response.data.data.properties.data;
          this.typeOfProperty = response.data.data.propertyTypes;
          this.availableLocations = response.data.data.locations;
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  getters: {
    // Getter to access all search parameters as a single object
    getSearchParams: (state) => state.searchParams,
    getAmenities: (state) => state.amenities,
    getListOfHotels: (state) => state.listOfHotels,
    getTypeOfProperty: (state) => state.typeOfProperty,
    getAvailableLocations: (state) => state.availableLocations,
    formattedCheckin: (state) => state.searchParams.checkin,
    formattedCheckout: (state) => state.searchParams.checkout,
    getRooms: (state) => state.searchParams.rooms,
    getSelectedPropertyId: (state) => state.hotelId,
    getSelectedHotelName: (state) => state.selectedHotelName,
    getSearch: (state) => state.isSearch,
    getsearchedHotelName: (state) => state.searchedHotelName,
  },
});
